import { render, staticRenderFns } from "./SaveFloatingButton.vue?vue&type=template&id=456ff72a"
import script from "./SaveFloatingButton.vue?vue&type=script&lang=js"
export * from "./SaveFloatingButton.vue?vue&type=script&lang=js"
import style0 from "./SaveFloatingButton.vue?vue&type=style&index=0&id=456ff72a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports